export default "__VITE_ASSET__WzkHrJO7__"